export default {
  filterSearch: 'Filter search',
  moreResults: 'Load more results',
  noResults: 'No results found. Submit a new search.',
  resetSearch: 'Reset tags',
  result: 'result',
  results: 'results',
  search: 'Search',
  startSearch: 'Start a new search',
  submitSearch: 'Search',
  labels: {
    activity: 'Activities',
    all: 'All',
    artwork: 'Artworks',
    contentType: 'Content types',
    resource: 'Resources',
    allSchoolLevels: 'All school levels',
  },
  keyword: 'Keyword',
  keywordPlaceholder: 'Medium, artist, artistic current,...',
};



// WEBPACK FOOTER //
// ./src/config/locales/en/search.js